<template>
  <div>
    <app-header><cp-nav></cp-nav></app-header>
    <section class="container">
      <div class="page-header">
        <h2>Início da Prova</h2>
      </div>
      <div v-if="horaInicio">
  			<p>Hora de Início:</p>
  			<h2>{{ horaInicio }}</h2>
  			<router-link to="/cp/chegadas" class="btn btn-default">Chegadas</router-link>
  		</div>
  		<div v-if="!horaInicio">
  			<button class="btn btn-default" @click="inicia">Inicia</button>
  		</div>
    </section>
  </div>
</template>

<script>
import AppHeader from '@/pages/layout/Header.vue'
import CpNav from './Nav.vue'
import axios from 'axios'

export default {
  name: 'CpInicio',
  components: {
    AppHeader,
    CpNav
  },
  data() {
		return {
			horaInicio: '00:00:00',
		}
	},
	methods: {
		inicia() {
			axios.post(process.env.WEB_API + 'setHoraPartida.php')
				.then(response => {
					if(response.data) {
						this.getHoraPartida();
					}
				})
		},
		getHoraPartida() {
			axios.get(process.env.WEB_API + 'getHoraPartida.php')
				.then(response => this.horaInicio = response.data.hora)
		},
	},
	mounted() {
		this.getHoraPartida()
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// Inicio.vue?e406e5e0